import { createCMSQuery, type ICMSQuery } from '@/modules/cms';

export interface CMSApiBase {
  id: number;
  locale: string;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
}

type CMSImageFormatDetail = {
  name: string;
  hash: string;
  ext: string;
  mime: string;
  width: number;
  height: number;
  size: number;
  path: string | null;
  url: string;
};

interface CMSImageFormats {
  thumbnail: CMSImageFormatDetail;
  large: CMSImageFormatDetail;
  medium: CMSImageFormatDetail;
  small: CMSImageFormatDetail;
}

export interface ICMSImageBase {
  id: number;
  name: string;
  alternativeText: string;
  caption: string;
  width: number;
  height: number;
  formats: CMSImageFormats | null;
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  providerMetadata: string | null;
  createdAt: string;
  updatedAt: string;
}

export type CMSImageBase = ICMSImageBase | null;

export interface CMSResponsiveImageComponent {
  image_1394: CMSImageBase;
  image_1088: CMSImageBase;
  image_936: CMSImageBase;
  image_622: CMSImageBase;
  image_452: CMSImageBase;
}

export type CMSCountryParams = {
  countryCodesInclude: string | null;
  countryCodesExclude: string | null;
};

export interface CMSArrayBase {
  id: number;
}

export const correctLang = (lang: string) => lang.replace('no', 'nn');

const DEFAULT_CMS_PAGE_SIZE = 100;

export const createCmsUrl = ({
  path,
  queryData,
}: {
  path: string;
  queryData?: ICMSQuery;
}) => {
  const query = createCMSQuery({
    ...queryData,
    pagination: {
      ...queryData?.pagination,
      pageSize: queryData?.pagination?.limit || DEFAULT_CMS_PAGE_SIZE,
    },
  });

  return `/${path}?${query}`;
};

export enum CMSGeneralButtonType {
  DEPOSIT = 'deposit',
  SHOW_MORE = 'show_more',
  EXPLORE = 'explore',
  READ_MORE = 'read_more',
  JOIN_NOW = 'join_now',
  PLAY_NOW = 'play_now',
}

export enum CMSGroupMode {
  AND = 'AND',
  OR = 'OR',
}

export type CMSGroupParams = {
  showGuestToggle?: boolean;

  groupsIncludeMode: CMSGroupMode;
  groupsInclude: string | null;
  groupsExcludeMode: CMSGroupMode;
  groupsExclude: string | null;

  durationFrom?: string | null;
  durationTo?: string | null;
};

export interface CMSOrder {
  order?: number;
}

export interface CMSToggle {
  cashierToggle: boolean;
  promoPageToggle: boolean;
  termsAndConditionsToggle: boolean;
  countdownToggle: boolean;
}

export enum EWeekday {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export type CMSWeekday = { weekday: EWeekday };

export type CMSScheduler = {
  scheduler?: CMSWeekday[];
};

export const getResponseCMS = <T>(data: { data: T }) => data.data;

export interface CMSHowToParticipateCard {
  id: number;
  title: string;
  description: string;
  cardImage: CMSImageBase;
}
